import { NewMap } from '@synergy/maps';
import { Flex } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { REACT_APP_MAPS_API_KEY } from '../../../../utils/config/configs';
import Spinner from '../../Atomics/Spinner';

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const ErrorMessage = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 16px;
    color: black;
    font-weight: bold;
`;

const MapWrapper = styled.div`
    height: ${props => (props.$marginTop ? 'calc(100% - ' + props.$marginTop + ')' : '100%')};
    margin-top: ${props => (props.$marginTop ? props.$marginTop : '0')};
    padding: 0;
    width: -webkit-fill-available;
`;
//#endregion

// Define the RegisterMapComponent function component
export const RegisterMapComponent = ({ headerheight, item, idCenter, disableClick }) => {
    const { t } = useTranslation();
    // Render RegisterMapComponent
    return (
        <MapWrapper $marginTop={headerheight}>
            {item ? (
                !isNaN(idCenter?.lat) && !isNaN(idCenter?.lng) ? (
                    <NewMap
                        apiKey={REACT_APP_MAPS_API_KEY}
                        configurations={{ ...mapConfiguration, lat: idCenter.lat, lng: idCenter.lng }}
                        pois={item}
                    />
                ) : (
                    <ErrorMessage>{t("Invalid POI position")}</ErrorMessage>
                )
            ) : (
                <Flex align="center" justify="center" className="full-h">
                    <Spinner stroke="green-4" />
                </Flex>
            )}
        </MapWrapper>
    );
}

const mapConfiguration = {
    "heading": 0,
    "hide": [
        "attraction",
        "sports_complex",
        "place_of_worship",
        "business",
        "government",
        "medical",
        "park",
        "school"
    ],
    "lat": 41.1621356,
    "lng": -8.6631531,
    "mapId": "15fb961c1d0a757",
    "showGTFSRealTime": false,
    "showPOIS": true,
    "showTraffic": false,
    "showTransit": false,
    "showPolygon": false,
    "showEvents": false,
    "styles": "default",
    "tilt": 0,
    "zoom": 12,
    "hrefLink": "/home/register/registerDetail/",
    "poiType": "pois-color-by-family",
    "showLegend": false,
    "legendArray": [],
    "legendDetail": true,
    "hideEventsInfo": false,
    "circleRadius": null
}